import React from 'react';
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from 'react-sortable-hoc';
import { Icon } from 'antd';

export const DragHandle = SortableHandle((props) => (
  <Icon
    type="drag"
    {...props}
  />
));

export const SortableItem = SortableElement((props) => <li {...props} />);

export const SortableList = SortableContainer((props) => <ul {...props} />);
